import { CascaderCategory } from '@clickguard/design-system'
import { IndustryTypes, SectorTypes } from 'config'

export const OTHER_INDUSTRY = 'other'
export const WEBSITE_INDUSTRIES: CascaderCategory[] = [
	...SectorTypes.map((sector) => ({
		id: sector.value,
		label: sector.label,
		items: IndustryTypes.filter(
			(industry) => industry.sectorId === sector.sectorId
		).map((industry) => ({ id: industry.value, label: industry.label }))
	})),
	{ id: OTHER_INDUSTRY, label: 'Other', items: [] }
]
